import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-history-date-edit-modal',
  templateUrl: './history-date-edit-modal.component.html',
  styleUrls: ['./history-date-edit-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HistoryDateEditModalComponent implements OnInit {
  @Input() validFrom: string;
  @Input() fieldLabel: string;

  validFromControl = new FormControl('', [Validators.required]);

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.validFromControl.setValue(this.toDateInputValue(this.validFrom));
  }

  submit(): void {
    if (this.validFromControl.invalid) {
      this.validFromControl.markAsTouched();
      return;
    }

    this.activeModal.close(this.validFromControl.value);
  }

  private toDateInputValue(value: string): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value.slice(0, 10);
    }

    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}`;
  }
}
